export default __webpack_public_path__ + "static/media/46.81f99203.jpg";